interface LoadingProps {
  full?: boolean;
  message?: string;
}

export const Loading = ({ full, message }: LoadingProps) => {
  const wrapperClass = full ? 'min-h-screen flex items-center justify-center' : 'py-8 text-center';
  return (
    <div className={wrapperClass} role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-2">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-200 border-t-blue-600" />
        <span className="text-sm text-gray-600">{message ?? 'Loading...'}</span>
      </div>
    </div>
  );
};
